import { apiCall, ApiConfig } from '../../config/api'
import { call, put, takeEvery } from '@redux-saga/core/effects'
import { AxiosResponse, AxiosError } from 'axios'
import { GET_TYPE_STORAGE } from '../types/typeStorageActionstypes'
import { TypeStorage } from '../../interfaces/TypeStorage/TypeStorage'
import { getTypeStorageAction } from '../actions/typeStorageActions'

export function* getTypeStorageAsync() {
  try {
    const { status, data }: AxiosResponse<TypeStorage[]> = yield call(
      apiCall,
      'GET',
      `${ApiConfig.TypeStorageApi}`
    )
    if (status === 200) {
      yield put(getTypeStorageAction(data))
    }
  } catch (error) {
    const serverError = error as AxiosError<string>
    yield put(getTypeStorageAction([], serverError.message))
  }
}

export function* watchGetTypeStorageAsync() {
  yield takeEvery(GET_TYPE_STORAGE, getTypeStorageAsync)
}
